import React, { useState } from 'react';
import '../Project.less';
import { Col, Form, Row } from 'react-bootstrap';
import moment from 'moment';
import BackBtn from '../../components/UI/BackBtn';
import useUserContext from '../../hooks/useUserContext';
import Required from '../../components/Required';
import DownloadLink from '../../components/common/DownloadLink';
import Page from '../../components/_layout/Page';
import { isAdminReadRestricted } from '../../services/rolesSvc';
import { range } from '../../helpers';

const styledHeading = { marginLeft: 0, marginBottom: 24, marginTop: 24 };

const defaultYear = Number(DEFAULT_YEAR_WEBPACK_REPORT);

export default function ProgramReports() {
  const userCtx = useUserContext();

  const [currentYear, setCurrentYear] = useState(defaultYear);
  const [years] = useState(range(2022, defaultYear));

  const getExportFileName = () => {
    const timestampString = `от ${moment().format('DD.MM.YYYY')}`;
    return `Отчет о реализации проектов программы за ${currentYear} год ${timestampString}.xlsx`;
  };
  if (!isAdminReadRestricted(userCtx) && !userCtx.perms.includes('strategies')) return <div style={{ color: 'red', background: 'white' }}>Недостаточно прав для просмотра страницы</div>;

  return (
    <Page className="project-page">
      <BackBtn />
      <h3 style={styledHeading}>Отчет о реализации проектов, входящих в стратегические проекты Программы развития</h3>
      <div style={{ marginTop: 20 }}>
        <Row className="mb-12">
          <Form.Group as={Col} md="2">
            <Form.Label>
              Отчетный год
              <Required />
            </Form.Label>
            <Form.Control
              required
              as="select"
              value={currentYear}
              onChange={(e) => setCurrentYear(parseInt(e.target.value))}
            >
              {years.map((year) => <option key={year} value={year}>{year}</option>)}
            </Form.Control>
            <Form.Control.Feedback type="invalid">Выберите год</Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col}>
            <DownloadLink
              variant="primary"
              type="submit"
              url={`/projs/0/reports/export?year=${currentYear}`}
              style={{ marginTop: '30px' }}
              filename={getExportFileName()}
            >
              Отчет о реализации проектов
            </DownloadLink>
          </Form.Group>
        </Row>
      </div>
    </Page>
  );
}

